import { render, staticRenderFns } from "./ChatPaletteNameInput.vue?vue&type=template&id=6db0ea76&lang=pug&"
import script from "./ChatPaletteNameInput.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteNameInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteNameInput.vue"
export default component.exports